import React, { useState, useEffect } from 'react'
import './NavigationData.css';
import * as signalR from "@microsoft/signalr";


function NavigationData({drone}){
    const [hubTelemNav, setHubTelemNav] = useState(hubNavConnect);
    const [updateTelemFromHub, setUpdateTelemFromHub] = useState(null);

    const [telemetry, setTelemetry] = useState([]);
    const [currentTelemetry, setCurrentTelemetry] = useState({imei: 0, batteryRemaining: -1, height: 0, speed: 0, sputniksCount: 0});

    useEffect(() => {
        return () => {
            console.log("NavigationData unmount");
            hubTelemNav.stop();
        };
    }, []);

    useEffect(() => {
        setTelem(updateTelemFromHub);
        
    }, [updateTelemFromHub]);

    useEffect(() => {
        switchTelemetry();
        //console.log("switch telemetry");
    }, [drone]);

    function switchTelemetry() {
        if(drone === null) {
            return;
        }

        setCurrentTelemetry(telemetry.find((item) => item.imei === drone.imei));
        /*
        const itemExists = telemetry.some((item) => item.imei === drone.imei);

        if(telemetry) {
            const telem = 
        }*/
    }

    function setTelem(msg) {
        setTelemetry((telems) => {
            const itemExists = telems.some((item) => item.imei === msg.imei);
            if(itemExists) {
                return telems.map((t) =>
                    t.imei === msg.imei
                      //? { ...t, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount }
                      ? { ...t, ...msg }
                      : t
                  )
            } else {
                //return [...telems, {imei: msg.imei, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount}];
                return [...telems, { ...msg }];
            }
        });

        if(msg?.imei === drone?.imei) {
            setCurrentTelemetry(msg);
        }
    }

    function hubNavConnect(){
        const protocol = new signalR.JsonHubProtocol();
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        connection.on('Telemetry', (message) =>
        {
            setUpdateTelemFromHub(message);
        });

        connection.start();
        return connection;
    }



    return(
        <>
            {drone == null ? <></> : 
                <div className='navigation-data'>
                    <div className='nav-box-left'><div className='nav-box-text addition-text'>ALT:</div> <div>{(currentTelemetry?.height ?? 0.0).toFixed(0)} m</div></div>
                    <div className='nav-box-right'><div className='nav-box-text addition-text'>SPD:</div> <div>{(currentTelemetry?.speed ?? 0.0).toFixed(1)} m/s</div></div>
                </div>
            }
        </>
    )
}

export default NavigationData;


/*
    const [pc, setPear] = useState();

    const [websocket, setWebSocket] = useState();

    function createPeerConnection() {
        let pc = new RTCPeerConnection({
            iceServers: [
              {
                urls: 'turn:turnzur.air-link.space', username:"airlink", credential:"lbjT3jXHt" // This is a public STUN server provided by Google.
              },
            ],
        });

        setPear(pc);  

        pc.addEventListener('iceconnectionstatechange', () =>
            console.log(' -> ' + pc.iceConnectionState));
    
        pc.addEventListener('icegatheringstatechange', () =>
            console.log(' -> ' + pc.iceGatheringState));
    
        pc.addEventListener('signalingstatechange', () =>
            console.log(' -> ' + pc.signalingState));

        pc.ontrack = (evt) => {
            document.getElementById('media').style.display = 'block';
            const video = document.getElementById('video');
            // always overrite the last stream - you may want to do something more clever in practice
            video.srcObject = evt.streams[0]; // The stream groups audio and video tracks
            video.play();
        };

        return pc;
    }

    function createWs() {
        setWebSocket(new WebSocket('ws://signallingzur.air-link.space/wstest?name=GS001D1&partnerName=001D1'));
        websocket.onopen = () => {
            //document.getElementById('start').disabled = false;
            console.log('ws open');
        }
        
        websocket.onmessage = async (evt) => {
            if (typeof evt.data !== 'string') {
                return;
            }
            if(evt.data == "partner connect") {
                console.log("partner connect")
            } else {
                const message = JSON.parse(evt.data);
                if (message.type == "offer") {
                    console.log('offer-sdp: ' + message.sdp);
                    await handleOffer(message)
                }
            }
        }
    }

    function sendRequest() {
        websocket.send(JSON.stringify({
            id: "server",
            type: "request",
        }));
    }

    async function handleOffer(offer) {
        pc = createPeerConnection();
        await pc.setRemoteDescription(offer);
        await sendAnswer(pc);
    }

    async function sendAnswer(pc) {
        await pc.setLocalDescription(await pc.createAnswer());
        await waitGatheringComplete();
    
        const answer = pc.localDescription;
        console.log('answer-sdp: '+ answer.sdp);
    
        websocket.send(JSON.stringify({
            id: "server",
            type: answer.type,
            sdp: answer.sdp,
        }));
    }

    async function waitGatheringComplete() {
        return new Promise((resolve) => {
            if (pc.iceGatheringState === 'complete') {
                resolve();
            } else {
                pc.addEventListener('icegatheringstatechange', () => {
                    if (pc.iceGatheringState === 'complete') {
                        resolve();
                    }
                });
            }
        });
    }
        */